/**
 * 日期格式化
 */
export function dateFormats(date) {
  let format = 'yyyy-MM-dd hh:mm:ss'
  if (date !== 'Invalid Date') {
    var o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      'S': date.getMilliseconds() // millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(RegExp.$1,
          RegExp.$1.length === 1 ? o[k] :
          ('00' + o[k]).substr(('' + o[k]).length))
      }
    }
    return format
  }
  return ''
}

export function getBirthdayFromIdCard(idCard) {
  var birthday = "";
  if (idCard != null && idCard != "") {
    if (idCard.length == 15) {
      birthday = "19" + idCard.substr(6, 6);
    } else if (idCard.length == 18) {
      birthday = idCard.substr(6, 8);
    }

    birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
  }
  return birthday;
}

// 判断时间是否在某一时间段内
export function nowInDateBetwen(d1, d2, date) {
  //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  var dateBegin = new Date(d1.replace(/-/g, "/"));//将-转化为/，使用new Date
  var dateEnd = new Date(d2.replace(/-/g, "/"));//将-转化为/，使用new Date
  var dateNow = new Date(date.replace(/-/g, "/"));//将-转化为/，使用new Date
  //var dateBegin = new Date(d1);//将-转化为/，使用new Date
  //var dateEnd = new Date(d2);//将-转化为/，使用new Date
  //var dateNow = new Date();//获取当前时间

  var beginDiff = dateNow.getTime() - dateBegin.getTime();//时间差的毫秒数
  var beginDayDiff = Math.floor(beginDiff / (24 * 3600 * 1000));//计算出相差天数

  var endDiff = dateEnd.getTime() - dateNow.getTime();//时间差的毫秒数
  var endDayDiff = Math.floor(endDiff / (24 * 3600 * 1000));//计算出相差天数
  if (endDayDiff < 0) {//已过期
      return false
  }
  if (beginDayDiff < 0) {//没到开始时间
      return false;
  }
  if (endDayDiff == 0) {
      return true
  }
  if (beginDayDiff == 0) {
      return true;
  }
  return true;
}

// 比较两数组得出重复部分
export function set(list,list1){
  const newArr = [];
  const newArr1 = [];
  list.forEach(item => {
      if (list1.some(it => it === item)) {
          newArr.push(item)
      }
      
  })
  list1.forEach(item => {
      if (list.every(it => it !== item)) {
          newArr1.push(item)
      }    
  })
  return newArr
}